/**
 * AI plan gate for customer web (matches admin subscription logic:
 * ai_plan === 1, ai_plan_expiry present, and expiry in the future).
 */
export function isCustomerAiMembershipActive(user) {
  if (!user) return false;
  const plan = Number(user.ai_plan);
  if (plan !== 1) return false;
  const exp = user.ai_plan_expiry;
  if (!exp) return false;
  return new Date(exp).getTime() > Date.now();
}

export const AI_MEMBERSHIP_REQUIRED_CODE = 'AI_MEMBERSHIP_REQUIRED';
